import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async claimIndex(projectId: Id) {
    return await api(route('api.v1.shared-fund.claim-index', projectId), 'get');
  },

  async create(projectGroupId: Id, data: ApiRequests['api.v1.project-groups.shared-funds.store']) {
    return await api(route('api.v1.project-groups.shared-funds.store', projectGroupId), 'post', {
      data,
      casts: {
        code: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.shared-funds.update']) {
    return await api(route('api.v1.shared-funds.update', id), 'patch', {
      data,
      casts: {
        code: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.shared-funds.destroy', id), 'delete');
  },
};
